<input
  #customNumberInput
  [type]="props.type"
  [formControl]="formControl"
  [formlyAttributes]="field"
  class="form-control"
  [ngClass]="props.inputClass"
  [attr.data-testing-id]="field.key"
  (input)="inputValidator($event)"
/>
